import { Children } from 'react'
import { cn } from '~/lib/utils'

export interface AvatarStackProps {
  children: React.ReactNode
  className?: string
  animate?: boolean
  size?: number
}

export function AvatarStack({ children, className, animate = false, size = 40, ...props }: AvatarStackProps) {
  return (
    <div
      className={cn('flex items-center -space-x-1', animate && 'hover:space-x-0 [&>*]:transition-all', className)}
      {...props}
    >
      {Children.map(children, (child, index) => {
        if (!child) {
          return null
        }

        return (
          <div
            className={cn(
              'size-full shrink-0 overflow-hidden rounded-full',
              '[&_[data-slot="avatar"]]:size-full',
              className,
            )}
            style={{
              width: size,
              height: size,
              maskImage: index
                ? `radial-gradient(circle ${size / 2}px at -${size / 4 + size / 10}px 50%, transparent 99%, white 100%)`
                : '',
            }}
          >
            {child}
          </div>
        )
      })}
    </div>
  )
}
